import { MotionContainer, MotionContainerProps } from "./Motion"

interface PageLayoutProps extends MotionContainerProps {
    isWide?: boolean
}

export function PageLayout({ isWide, children, ...containerProps }: PageLayoutProps) {
    const defaultProps = isWide
        ? {
              maxW: "1280px",
              pt: [0, 0, 8],
              pb: "200px",
          }
        : {
              maxW: [null, "container.sm"],
              pt: [0, 0, 8],
              pb: "200px",
          }

    return isWide ? (
        <MotionContainer
            {...defaultProps}
            {...containerProps}
            pb={{ base: "140px", md: "80px" }} // for mobile tab bar space
        >
            {children}
        </MotionContainer>
    ) : (
        <MotionContainer
            {...defaultProps}
            {...containerProps}
            pb={{ base: "140px", md: "80px" }} // for mobile tab bar space
        >
            {children}
        </MotionContainer>
    )
}
